import { render, staticRenderFns } from "./OtrosPerView.vue?vue&type=template&id=6de46869&scoped=true"
import script from "./OtrosPerView.vue?vue&type=script&lang=js"
export * from "./OtrosPerView.vue?vue&type=script&lang=js"
import style1 from "./OtrosPerView.vue?vue&type=style&index=1&id=6de46869&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de46869",
  null
  
)

export default component.exports